import { useEffect } from 'react';
import Swal from 'sweetalert2';

export default function RNEInfo({ data, onConfirm, onCancel }) {

  useEffect(() => {
    if (!data) return;

    // CAS ERREUR
    if (data.error === true) {
      Swal.fire({
        title: 'Erreur',
        html: `<div class="small">${data.message || 'Une erreur est survenue'}</div>`,
        showCancelButton: false,
        confirmButtonText: 'OK',
        icon: undefined, // PAS D'ICONE
        customClass: {
          popup: 'swal2-no-icon',
          confirmButton: 'btn btn-sm btn-danger'
        },
        buttonsStyling: false
      }).then(() => {
        onCancel && onCancel();
      });

      return;
    }

    // CAS OK
    Swal.fire({
      title: 'Informations entreprise',
      html: `
        <div class="text-start small">
          <div><strong>Nom :</strong> ${data.denomination}</div>
          <div><strong>Adresse :</strong> ${data.adresse_siege}</div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      icon: undefined, // PAS D'ICONE
      customClass: {
        popup: 'swal2-no-icon',
        confirmButton: 'btn btn-sm btn-primary mx-2',
        cancelButton: 'btn btn-sm btn-secondary mx-2'
      },
      buttonsStyling: false
    }).then((result) => {
      if (result.isConfirmed) {
        onConfirm && onConfirm(data);
      } else {
        onCancel && onCancel();
      }
    });

  }, [data]);

  return null;
}